export function getListItemName(name: string, index: number): string {
  return `${name}__${index}`;
}
